import { api } from './api';

/** Lee un File como base64 (sin el prefijo data:). Para mandar a la AI. */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve((reader.result as string).split(',')[1] ?? '');
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

/**
 * Sube un File a R2. Ruta RÁPIDA: URL prefirmada → PUT DIRECTO navegador→R2 (no pasa por la
 * RAM del backend; clave para escalar con muchos uploads simultáneos). Si el PUT directo falla
 * (ej. CORS del bucket R2 aún no configurado), cae automáticamente al fallback por el backend
 * (base64), así las subidas NUNCA se rompen. Devuelve la key para guardar.
 */
/** Tope del PUT directo a R2 antes de caer al fallback por el backend. */
const PUT_TIMEOUT_MS = 120_000;

export async function uploadFile(
  file: File,
  category: 'checks' | 'invoices' | 'estimates' | 'authorizations' | 'proofs' | 'misc' | 'marketing',
): Promise<string> {
  const contentType = file.type || 'application/octet-stream';
  // 1) Directo a R2 (presigned PUT).
  try {
    const { key, url } = await api.post<{ key: string; url: string }>('/api/uploads/presign', {
      category, filename: file.name, contentType,
    });
    // Con tope: si el PUT se traba (red del usuario / R2 sin responder), cortamos y caemos al
    // fallback por el backend en vez de dejar el "Uploading…" girando para siempre.
    const put = await fetch(url, {
      method: 'PUT', body: file, headers: { 'Content-Type': contentType },
      signal: AbortSignal.timeout(PUT_TIMEOUT_MS),
    });
    if (put.ok) return key;
  } catch { /* CORS/red → fallback por el backend */ }
  // 2) Fallback: a través del backend (base64). Funciona sin CORS, pero usa RAM del servidor.
  const base64 = await fileToBase64(file);
  const r = await api.post<{ key: string }>('/api/uploads', {
    category, filename: file.name, contentType, base64,
  });
  return r.key;
}

/**
 * Imágenes del portapapeles (Cmd+Shift+4 → Cmd+V), como en Monday: pegar una captura la adjunta
 * en vez de obligar a guardarla en el disco y subirla a mano. Las capturas llegan con nombre
 * genérico ("image.png") → se les pone uno único para poder distinguirlas en la lista.
 */
export function imagesFromClipboard(e: React.ClipboardEvent): File[] {
  const out: File[] = [];
  for (const it of Array.from(e.clipboardData?.items ?? [])) {
    if (it.kind !== 'file' || !it.type.startsWith('image/')) continue;
    const f = it.getAsFile();
    if (!f) continue;
    const named = f.name && f.name !== 'image.png' ? f.name : `screenshot-${new Date().toISOString().replace(/[:.]/g, '-')}.${(f.type.split('/')[1] || 'png')}`;
    out.push(new File([f], named, { type: f.type }));
  }
  return out;
}
